import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { ToolsService } from '../services/tools.service';

/** Keep in sync with api/services/user.js `UserService.isAdmin`. */
export const BUK_ADMIN_USER_IDS = [
  80, // Goncalves
  68, // Moniz
  69, // Santos
  70, // Gois
  1480, // Catarina
  6975, // catarina catarina.monteiro+reunioes@buk.pt
  10575, // Maria Loureiro
  21717, // Zemi
  21725, // Zemi demos
  76048, // andremoniz+testefaturacao2@gmail.com (local)
];

export function getUserIdFromJwt(token: string | null | undefined): number | null {
  if (!token || typeof token !== 'string') {
    return null;
  }

  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) {
      return null;
    }

    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(normalized));
    const id = Number(payload?.id);

    return Number.isFinite(id) ? id : null;
  } catch (_err) {
    return null;
  }
}

export function isBukAdminUser(user: { id?: number; token?: string } | null | undefined): boolean {
  if (!user) {
    return false;
  }

  const id = user.id ?? getUserIdFromJwt(user.token);
  return !!id && BUK_ADMIN_USER_IDS.includes(id);
}

@Injectable({
  providedIn: 'root'
})
export class BukAdminGuard  {
  constructor(
    @Inject(PLATFORM_ID) protected platformId,
    private router: Router,
    private toolsService: ToolsService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // SSR has no access to localStorage. Allow the route through so a full page
    // load of /admin is not redirected away; AdminComponent re-checks in the browser.
    if (!isPlatformBrowser(this.platformId) || !this.toolsService.localStorageSupport()) {
      return true;
    }

    const raw = localStorage?.getItem('currentUser');
    if (raw) {
      try {
        const parsedUser = JSON.parse(raw);
        if (isBukAdminUser(parsedUser)) {
          return true;
        }
      } catch (_err) {
        // fall through to redirect
      }
    }

    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.canActivate(next, state);
  }
}
